import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NavBar from "@/components/NavBar";
import api from "@/lib/api";

export default function HowItWorks() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/smart-method").then((r) => setData(r.data)).catch(() => {});
  }, []);

  return (
    <div className="App" data-testid="page-how-it-works">
      <NavBar />
      <section className="max-w-4xl mx-auto px-6 lg:px-10 py-14">
        <div className="aa-eyebrow mb-3">How it works</div>
        <h1 className="font-display text-4xl lg:text-5xl leading-tight">
          The <span className="serif-italic">SMART method</span>.
        </h1>

        {!data ? (
          <div className="aa-eyebrow mt-12">Loading…</div>
        ) : (
          <>
            <p className="mt-6 text-lg text-[var(--aa-text-2)] leading-relaxed max-w-3xl">{data.intro_short}</p>
            <p className="mt-4 text-base text-[var(--aa-text-2)] leading-relaxed max-w-3xl">{data.intro_long}</p>

            <div className="mt-12 space-y-6">
              {data.phases.map((p, i) => {
                const tintClass = {
                  skin_resilience: "aa-card-warm",
                  making_actives_count: "aa-card-sage",
                  radiance_from_within: "aa-card-blush",
                  targeted_treatments: "aa-card-stone",
                }[p.key] || "";
                return (
                <div
                  key={p.key}
                  data-testid={`smart-phase-${p.key}`}
                  className={`aa-card ${tintClass} p-7 lg:p-9 ${p.in_companion === false ? "opacity-80" : ""}`}
                >
                  <div className="flex items-start gap-5">
                    <div className="font-display text-5xl lg:text-6xl text-[var(--aa-text)] leading-none w-20 shrink-0">
                      {p.letter}
                    </div>
                    <div className="flex-1">
                      <div className="aa-eyebrow mb-1">Phase {i + 1}{p.in_companion === false ? " · in the full Ageless Alchemy program" : ""}</div>
                      <div className="font-display text-2xl lg:text-3xl">{p.title}</div>
                      <div className="mt-5 space-y-4">
                        <div>
                          <div className="aa-eyebrow mb-1">Why</div>
                          <p className="text-[var(--aa-text-2)] leading-relaxed">{p.why}</p>
                        </div>
                        <div>
                          <div className="aa-eyebrow mb-1">What</div>
                          <p className="text-[var(--aa-text-2)] leading-relaxed">{p.what}</p>
                        </div>
                        <div>
                          <div className="aa-eyebrow mb-1">What to expect</div>
                          <p className="text-[var(--aa-text-2)] leading-relaxed">{p.expect}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
              })}
            </div>

            <div className="aa-card p-7 lg:p-9 mt-10 fade-in">
              <div className="aa-eyebrow mb-3">Ready to keep going?</div>
              <div className="font-display text-2xl">Choose your path.</div>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link to={data.cta.member_href} data-testid="smart-cta-member" className="aa-cta-primary">
                  {data.cta.member_label} →
                </Link>
                <a href={data.cta.non_member_href} target="_blank" rel="noopener noreferrer" data-testid="smart-cta-non-member" className="aa-cta-secondary">
                  {data.cta.non_member_label}
                </a>
              </div>
              <div className="mt-4 text-sm text-[var(--aa-text-3)]">
                <Link to="/dashboard" data-testid="smart-cta-dashboard" className="underline underline-offset-4 hover:text-[var(--aa-text)]">Go to dashboard</Link>
              </div>
            </div>
          </>
        )}
      </section>
    </div>
  );
}
